{% block sw_cms_block_acris_blog_image %}
    <div class="sw-cms-preview-acris-blog-image">
        <img
                :src="assetFilter('/acrisblog/administration/static/img/cms/acris_preview_landscape_small.jpg')"
                alt=""
        >
    </div>
{% endblock %}
